

interface CategoryTabsProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryTabs({ categories, activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-3 py-1.5 text-sm font-ui transition-all duration-300 rounded-[15%] relative ${
            activeCategory === category
              ? 'bg-sepia-800 text-paper shadow-lg transform scale-105'
              : 'vintage-paper-subtle text-sepia-700 hover:bg-sepia-100/70 hover:shadow-md'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
}
